import { Link } from '@reach/router';
import { AppPath } from 'appConstants';
import { Spinner } from 'components/spinner/Spinner';
import SubjectSiteLayout from 'components/subjectSite/SubjectSiteLayout';
import useFullHeight from 'components/subjectSite/useFullHeight';
import WarningIcon from 'images/Icon_Warning.png';
import React, { useRef } from 'react';

type Props = {
  status: null | 'notFound' | 'error';
};

const ErrorPage: React.FC<{ bNotFound: boolean }> = ({ bNotFound }) => {
  const blockRef = useRef<HTMLDivElement>(null);

  useFullHeight(blockRef);

  return (
    <div className="ErrorPage ContainerFixed" ref={blockRef}>
      <div className="ErrorInner">
        <div className="Img">
          <img src={WarningIcon} alt={bNotFound ? 'Sorry' : 'Website Error'} />
        </div>
        <div className="Desc">
          {bNotFound ? (
            <>
              <h1 className="Title">Sorry, that page does not exist</h1>
              <p className="Txt">
                Please return to the{' '}
                <Link to={AppPath.DASHBOARD}>Homepage</Link>.
              </p>
            </>
          ) : (
            <>
              <h1 className="Title">Website Error</h1>
              <p className="Txt">
                Unfortunately an error has occurred processing your request,
                please try again.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

/**
 * A lesson page while it loads, or the subject site's error page when it is not found or fails to
 * load
 */
const LessonPageStatus: React.FC<Props> = ({ status }) => (
  <SubjectSiteLayout>
    {status === null ? (
      <Spinner />
    ) : (
      <ErrorPage bNotFound={status === 'notFound'} />
    )}
  </SubjectSiteLayout>
);

export default LessonPageStatus;
